import React from "react";
import { Box, Typography, Link } from "@mui/material";
import DocumentItem from "components/Documents/StepZeroDocuments/stepZeroDocument"; 

const QuestionCardDownload = () => {
  return (
    <Box 
      sx={{ 
        mt: 3, 
        p: 2.5, 
        borderRadius: 2, 
        backgroundColor: "#F8FAFC", 
        border: "1px solid #E4E7EC", 
        borderLeft: "4px solid #23576B"
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#23576B", mb: 1 }}>
        Workshop Question Card
      </Typography>
      
      <Typography variant="body2" sx={{ color: "#667085", mb: 3 }}>
        Download the Question Card below and work with your group to reflect and evaluate how components of the selected{" "}
        <Link 
          href="https://www.ruractive.eu/resources/solution-factsheets" 
          target="_blank" 
          rel="noopener noreferrer"
          sx={{
            color: "#23576B",
            fontWeight: 600,
            textDecorationColor: "#23576B",
            "&:hover": { color: "#13A89E", textDecorationColor: "#13A89E" }
          }}
        >
          Solutions Factsheets
        </Link>{" "}
        can solve your local challenge.
      </Typography>

      <Box sx={{ width: "100%" }}>
        <DocumentItem
          title="LW2_Question_Card"
          file="/documents/LW2_Question_Card.pdf" 
        />
      </Box>
    </Box>
  );
};

export default QuestionCardDownload;